module.exports = __webpack_public_path__ + "static/media/Mobile.8521aba8.jpg";